import { PageResponse } from '@core/entities/pagination'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { registerItemKeys } from '../registerItemKeys'

import { RequestTypes } from '../requestTypes'
import { AuditResult, IAuditResult } from '@core/entities/audit/AuditResult'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = ({ content }: PageResponse<IAuditResult>) => {
  return content.map((audit) => AuditResult.new(audit))
}

export const useGetRegisterItemTimeline = (
  payload: RequestTypes['getRegisterItemTimeline'],
  options: UseQueryOptions<
    PageResponse<IAuditResult>,
    RequestErrorType,
    Array<AuditResult>
  > = {},
) => {
  const registerItemTimeline = registerItemKeys
    .byId(payload)
    ._ctx.timeline(payload)

  return useQuery({
    select: dataTransformer,
    ...registerItemTimeline,
    ...options,
  })
}
